import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import FakeButton from "../../../Components/FormComponents/FakeButton";
import Fetch from "../../helpers/fetch";
import { apiUrl } from "../../../config";
import UserContext from "../../../store/UserStore/context";
import Paw from "../Paw.svg";
import Check from "./Check";
import styles from "./index.module.css";

const paymentOptions = [
  { id: "full", label: "100% від суми", title: "Оплата" },
  { id: "half", label: "50% суми", title: "Оплата 50%" },
  { id: "parts", label: "Оплата частинами", icon: Paw, title: "Оплата частинами" },
];

const fullPrice = 28600;

// Whatever goes wrong on the way to the bank, the client can only do one
// thing about it, so every failure shows the same line.
const PAYMENT_ERROR = "Не вдалося створити оплату. Спробуй ще раз.";

function formatPrice(price) {
  return price.toLocaleString("uk-UA").replace(/\u00A0/g, " ");
}

function formatLastPaymentDate(value) {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString("uk-UA", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

export function PaymentStage({ details }) {
  const navigate = useNavigate();
  const context = useContext(UserContext);
  const [selectedPayment, setSelectedPayment] = useState("full");
  const [inviteCode, setInviteCode] = useState("");
  const [request, setRequest] = useState(false);
  const [error, setError] = useState("");
  const displayedPrice = selectedPayment === "half" ? fullPrice / 2 : fullPrice;
  const selectedOption = paymentOptions.find(
    (option) => option.id === selectedPayment,
  );
  const lastPaymentDate = formatLastPaymentDate(
    context.store.user?.lastPaymentAt,
  );

  async function submitPayment() {
    if (request) return;

    const isInstallment = selectedPayment === "parts";
    const endpoint = isInstallment
      ? "/api/intensive/payment/mono/installment"
      : "/api/intensive/payment/mono";

    setRequest(true);
    setError("");

    try {
      const res = await Fetch.post(apiUrl(endpoint), {
        email: details?.email,
        name: details?.name,
        phoneNumber: details?.phoneNumber,
        tgUsername: details?.tgUsername,
        isHalfPrice: selectedPayment === "half",
        time: details?.time,
      });

      if (!res.ok) {
        setError(PAYMENT_ERROR);
        return;
      }

      const paymentData = await res.json();

      // Full and half price go through the provider's checkout page.
      if (paymentData?.link) {
        window.location = paymentData.link;
        return;
      }

      // "Оплата частинами" has no checkout page: the bank answers with
      // { orderId, monoOrderId, status: "AWAITING_APP_CONFIRMATION" } and the
      // client confirms the split inside the monobank app. Send them to the
      // status screen, which polls /api/intensive/order-status until the order
      // settles.
      if (paymentData?.orderId) {
        const query = new URLSearchParams({ confirm: "app" });
        if (details?.email) query.set("email", details.email);
        navigate(`/successful-payment?${query}`);
        return;
      }

      console.error("Unexpected payment response", paymentData);
      setError(PAYMENT_ERROR);
    } catch (error) {
      console.error("Payment request failed", error);
      setError(PAYMENT_ERROR);
    } finally {
      setRequest(false);
    }
  }

  return (
    <div className={styles.container}>
      <h1>{selectedOption?.title}</h1>

      {lastPaymentDate ? (
        <div className={styles.lastPayment}>
          <Check />
          <span>
            Остання оплата: <b>{lastPaymentDate}</b>
          </span>
        </div>
      ) : null}

      <div className={styles.paymentTabs} aria-label="Спосіб оплати">
        {paymentOptions.map((option) => (
          <button
            key={option.id}
            type="button"
            className={[
              styles.paymentTab,
              selectedPayment === option.id ? styles.activePaymentTab : "",
            ].join(" ")}
            onClick={() => setSelectedPayment(option.id)}
          >
            {option.icon ? (
              <img src={option.icon} alt="" aria-hidden="true" />
            ) : null}
            <span>{option.label}</span>
          </button>
        ))}
      </div>

      <div className={styles.priceRow}>
        <span className={styles.price}>{formatPrice(displayedPrice)}</span>
        <span className={styles.currency}>грн</span>
        <span className={styles.required}>*</span>
      </div>

      <p className={styles.caption}>
        *тобто лише 550 грн за заняття,
        <br />
        замість 620 (стандартна ціна групового заняття)
      </p>

      {selectedPayment === "parts" ? (
        <div className={styles.installmentWarning}>
          Для оплати частинами на вказаний номер телефону має бути
          зареєстрований рахунок у Monobank.
        </div>
      ) : null}

      {/*<div className={styles.invite}>*/}
      {/*  <div>*/}
      {/*    <h2>Маєш код запрошення?</h2>*/}
      {/*    <p>Введи код, щоб отримати додаткову знижку -10%</p>*/}
      {/*  </div>*/}
      {/*  <div className={styles.codeControl}>*/}
      {/*    <input*/}
      {/*      type="text"*/}
      {/*      inputMode="numeric"*/}
      {/*      value={inviteCode}*/}
      {/*      onChange={(event) => setInviteCode(event.target.value)}*/}
      {/*      placeholder="123456"*/}
      {/*    />*/}
      {/*    <button type="button" aria-label="Застосувати код">*/}
      {/*      <span />*/}
      {/*    </button>*/}
      {/*  </div>*/}
      {/*</div>*/}

      {error ? <div className={styles.error}>{error}</div> : null}

      <div className={styles.button}>
        <FakeButton onClick={submitPayment} disabled={request}>
          {request ? "Створюємо оплату..." : "До оплати"}
        </FakeButton>
      </div>

      {/* opens in a new tab on purpose: PaymentForm paints the body background
          and never restores it, so a client-side navigation would carry the
          blue background onto the white info page */}
      <a
        className={styles.installmentLink}
        href="/installment"
        target="_blank"
        rel="noreferrer"
      >
        Покупка частинами monobank | Universal Bank
      </a>
    </div>
  );
}
